import moment from "moment";

export const isExpired = (date: string): boolean => {
  return moment(date).isBefore(moment(), "day");
};
